import React from "react";
import { API_ROUTE } from "../../../../const/apiRoute";
import Repository from "../../../../_base/helper/HttpHelper";
import { MessageResponse } from "../../../../model/MessageResponse";
import { Box, Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

const AddProduct = ({ idItems, idFbAds, onClose, fetchDataList }: DeleteProduct) => {
    
  const handleAdd = async () => {
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    const res = await repository.post<MessageResponse<boolean>>(
      `${API_ROUTE.ADD_PRODUCT_SELECTION}`,
      {
        "fbAdsId": idFbAds,
        "listItemIds": idItems
      }
    );
    if (res)
      if (res.success) {
        NotificationExtension.Success("Thêm thành công !");
        fetchDataList()
        onClose((prev: any) => !prev);
      } else NotificationExtension.Fails("Thêm thất bại !");
    modals.closeAll();
  };
  return (
    <Box size={"auto"}>
      <Text size="20px" mt={5}>
        Bạn có chắc chắn muốn thêm những sản phẩm này ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="blue"
          onClick={handleAdd}
          leftSection={<IconCheck size={18} />}
        >
          Thêm
        </Button>
      </Group>
    </Box>
  );
};
type DeleteProduct = {
  idItems: (number | string)[];
  idFbAds: (number | string);
  fetchDataList: ()=>void
  onClose: any;
};
export default AddProduct;
